const waves = Array.prototype.slice.call(document.querySelectorAll('svg.wave'));

if(waves.length > 0) {
    waves.forEach((wave) => {
        wave.setAttribute('preserveAspectRatio', 'none')
    })
}